import { useState, useParams, FaSearch, FaFileExcel, BsSortUpAlt, noDatapng, DataTable, FaPlusCircle, moment } from '../../common/common.jsx';
import Sidebar from '../Components/Sidebar.jsx';
import Topbar from '../Components/Topbar.jsx';
import MidViewBuyerOrders from '../../middleware/Orders/MidViewBuyerOrders.jsx';
import Navigations from '../../common/useNavigation.js';
const ViewOrders = () => {
  const { type } = useParams();
  const { navigateOrderDetails } = Navigations();
  const [issidebarOpen, setIssidebarOpen] = useState(true);
  const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
  const { users, seacrh, setSearch, exporttoExcelData, orders, filteredCategories, handleRowSelected } = MidViewBuyerOrders(type);
  if (Array.isArray(users) && users.length > 0) {
    var AppID = users[0]['AppID'];
    var ProfilePic = users[0]['ProfilePic'];
    var usertype = users[0]['UserType'];
    var username = users[0]['FullName'];
    var RegistrationDate = users[0]['RegistrationDate'];
    var RegistrationDate = moment(RegistrationDate).format('DD-MMM-YYYY');
    var userActive = users[0]["Status"]

  }
  // console.log({orders:orders});
  const columns = [

    {
      name: "Order ID",
      style: {
        color: '#0089ff ',
        fontSize: '14px',
        fontWeight: '500',
        padding: '8px 16px',
      },
      sortable: true,
      //selector: (row) => row.order_unique_key,
      cell: row => {
        function getKeyByValue(object, row) {
          return object[row];
        }
        return (
          <a
            className="productName"
            onClick={() => navigateOrderDetails(row.order_unique_key, type)}
            rel="noopener noreferrer">
            {row.order_unique_key}

          </a>
        );
      },
    },
    {
      name: "Supplier Name",

      style: {
        color: 'black ',
        fontSize: '15px',
        fontWeight: '500',
      },
      sortable: true,
      selector: (row) => row.full_name,
    },
    {
      name: 'Total Quantity',

      style: {
        color: 'black ',
        fontSize: '15px',
        fontWeight: '500',
      },
      sortable: true,
      selector: (row) => row.total_quantity
    },
    {
      name: 'Total Amount',
      style: {
        color: 'black',
        fontSize: '15px',
        fontWeight: '500',
      },
      sortable: true,
      selector: (row) => (parseFloat(row.ammount) || 0).toFixed(2)
    },
    {
      name: 'Order Date',

      style: {
        color: 'black ',
        fontSize: '15px',
        fontWeight: '500',
      },
      sortable: true,
      selector: (row) => moment(row.order_created_date).format(' MMM DD YYYY'),
    },

    {
      name: "Order Status",
      sortable: true,
      conditionalCellStyles: [
        {
          when: row => row.order_status !== undefined,
          style: row => {
            const statusMap = {
              1: { label: 'Order Placed', color: 'green' },
              2: { label: 'Confirm', color: 'green' },
              3: { label: 'On Hold', color: 'red' },
              4: { label: 'On Process', color: 'brown' },
              5: { label: 'Packed', color: 'blue' },
              6: { label: 'Dispatch', color: 'orange' },
              7: { label: 'Complete', color: 'purple' },
              8: { label: 'On Transit', color: 'skyblue' },
              9: { label: 'Delivered', color: 'maroon' },
              10: { label: 'Cancelled', color: 'aqua' },
              11: { label: 'Out of Stock', color: 'red' },
            };

            const status = statusMap[row.order_status] || { label: null, color: 'gray' };

            return {
              fontSize: '14px',
              fontWeight: '700',
              color: status.color,
            };
          },
        },
      ],
      selector: (row) => {
        const statusMap = {
          1: 'Order Placed',
          2: 'Confirm',
          3: 'On Hold',
          4: 'On Process',
          5: 'Packed',
          6: 'Dispatch',
          7: 'Complete',
          8: 'On Transit',
          9: 'Delivered',
          10: 'Cancelled',
          11: 'Out of Stock',
        };

        return statusMap[row.order_status] || null;
      },
    },
    {
      name: 'Update Date',
      width: '150px',
      style: {
        color: 'black ',
        fontSize: '15px',
        fontWeight: '500',
      },
      sortable: true,
      selector: (row) => moment(row.order_modified_date).format(' MMM DD YYYY'),
    },
  ]

  return (
    <div className="md:flex md:flex-row md:w-full">
      <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
        <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} userActive={userActive} />
      </div>
      <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
        <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
        <div className="grid grid-cols-12">
          <div className="col-start-1 col-end-13">
            <div className=" p-2 text-xl  text-[#1e3a8a]  ">
              <div className='px-3'>
                <h1 className=' text-lg text-theme-color-text font-bold'> Orders </h1>
                <p className=' text-gray-600 text-[16px] '>select attributes as per your products range, code, name and category are required attributes. you have to an option to include all attributes while adding product data but displaying only few of them to your buyers.  </p>
              </div>
            </div>


            <div className="border-0 flex-row rounded-xl m-3 bg-white shadow-xs">
              <div className=' relative flex flex-col min-w-0 break-words'>
                <div className='p-4'>
                  <div className='flex flex-row justify-between '>
                    <h5 className=" capitalize text-xl font-bold mb-0">View Orders</h5>
                    <div className='flex flex-col lg:flex-row'>
                      <div className='relative bg-gray-100 p-2   rounded-md border-2 border-solid border-gray-200' >
                        <FaSearch className='h-5 w-5 absolute left-3 ' />
                        <input className="bg-transparent ml-6 pl-5 focus:outline-none w-full pr-5  " type="text" name="searchbox" id='searchbox' placeholder='Search anything from table '
                          value={seacrh}
                          onChange={(e) => setSearch(e.target.value)} />
                      </div>
                      <button type="submit" className="relative mx-2 rounded-md group px-3 h-12  flex space-x-2 items-center bg-blue-600 text-white  w-[220px]" onClick={exporttoExcelData}>
                        <span className="relative text-md text-white font-semibold pl-0">Download Excelsheet</span>
                        <div className="flex items-center h-12 w-12 rounded-full bg-blue-600 absolute right-[0px] z-20 drop-shadow-2xl ">
                          <FaFileExcel className="h-5 w-5 text-white translate-x-4 transition duration-300 " />
                        </div>
                      </button>
                      <button type="submit" className="relative mx-2 rounded-md group px-3 h-12  flex space-x-2 items-center bg-button-color  w-[200px]" >
                        <span className="relative text-md text-black font-semibold pl-0">Place New Order</span>
                        <div className="flex items-center h-12 w-12 rounded-full bg-button-color absolute right-[0px] z-20 drop-shadow-2xl ">
                          <FaPlusCircle className="h-3 w-3 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                        </div>
                      </button>
                    </div>
                  </div>

                  {(orders && orders.length > 0) ? (
                    <DataTable
                      className="scrollhost"
                      columns={columns}
                      data={filteredCategories}
                      pagination
                      responsive

                      sortIcon={<BsSortUpAlt className="mx-1" />}
                    />
                  ) : (
                    <div className="flex flex-col items-center justify-center">
                      <img src={noDatapng} alt="No Data" height={260} width={260} />
                      <h1 className="text-lg text-gray-300 font-bold mt-4">Oops! No Data Found</h1>
                    </div>
                  )}


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewOrders